// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__6pzcp","rotate":"LoadingSpinner_rotate__cTasr","text":"LoadingSpinner_text__tqhuI"};